/**
 * 「今天是哪一天」——🔴 **端侧唯一实现**（原先只在 `NewTransactionPage` 里，㉝ 批保单表单也要用）
 *
 * ## 为什么不能用 `toISOString().slice(0, 10)`
 *
 * 那是 **UTC 日**。北京时间 08:00 之前调用它会得到**前一天** ——
 * 用户打开「记一笔」，日期默认值就差了一天，而且**看不出来**（不是报错，是一个看起来正常的错日期）。
 *
 * ## ⚠️ 它与服务端的「账本日历日」不是同一个东西（已登记）
 *
 * 服务端一律用 `localDayOf(ms, ledger.timezone)` 取**账本时区**下的一天
 * （架构 §4.5；`NetWorthController` 与流水写入都这么取）。本函数取的是**浏览器本地日** ——
 * 当用户浏览器时区 ≠ 账本时区时会差一天。
 *
 * 现状：它是**表单的默认值**（人可改），不是口径判定；且本项目 P0 的用户就是账本持有者本人。
 * ⇒ 维持"浏览器本地日"（与 v1 一致），**不在此处引入时区依赖**（端侧没有账本时区字段）。
 * 🔴 若将来出现"跨时区家庭"，正解是让服务端在 `LedgerSummary` 里下发 `timezone`，
 * 本函数改成 `localDayOf(Date.now(), tz)` —— **改这一处**。
 */

/** 浏览器本地日历日（`YYYY-MM-DD`） */
export function localToday(): string {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}
